import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import axios from "axios";
import { useUserAuth } from "../../../context/UserAuthContext";
import { useDropzone } from "react-dropzone";

const AddPreviousWork = () => {
  const [uploadErrors, setUploadErrors] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const { user, language, token } = useUserAuth();
  const merchant_id = user.uid;
  const [previousImgUrl, setPreviousImgUrl] = useState([]);
  const [previousImgProgress, setPreviousImgProgress] = useState(0);
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/previous-work/${merchant_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setPreviousImgUrl(res.data.data || []);
      setInitialLoading(false);
    } catch (error) {
      console.log(`Error fetching merchant data: ${error}`);
      setInitialLoading(false);
    }
  };
  const [selectedFiles, setSelectedFiles] = useState([]);
  
  const onDrop = async (acceptedFiles) => {
  const validFiles = [];
  const errors = [];

  for (const file of acceptedFiles) {
    const isValid = await new Promise((resolve) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        const width = img.width;
        const height = img.height;
        URL.revokeObjectURL(img.src);

        const isLandscapeValid = width >= 1024 && height >= 683;
        const isPortraitValid = width >= 683 && height >= 1024;

        if (isLandscapeValid || isPortraitValid) {
          resolve(true);
        } else {
          errors.push(
            `${file.name} must be at least 1024x683 (landscape) or 683x1024 (portrait)`
          );
          resolve(false);
        }
      };

      img.onerror = () => {
        errors.push(`${file.name} is not a valid image`);
        resolve(false);
      };
    });

    if (isValid) {
      file.preview = URL.createObjectURL(file);
      validFiles.push(file);
    }
  }

  setUploadErrors(errors);
  setSelectedFiles((prev) => [...prev, ...validFiles]);
};

  const removeImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const handleUpload = async () => {
    const totalImages = (previousImgUrl?.length || 0) + selectedFiles.length;

    if (totalImages < 4) {
      setUploadErrors([
        `Minimum 4 images required. Currently you have ${totalImages}`,
      ]); 
      return;
    }

    try {
      setUploading(true);
      setUploadErrors([]);

      const totalImages = (previousImgUrl?.length || 0) + selectedFiles.length;

      if (totalImages < 4) {
        setUploadErrors([
          `Minimum 4 images required. Currently: ${totalImages}`,
        ]);
        setUploading(false);
        return;
      }

      const uploadedImages = [];

      for (const file of selectedFiles) {
        const formData = new FormData();
        formData.append("merchant_id", merchant_id);
        formData.append("image", file);

        const response = await axios.post(
          `${base_url}/api/v1/previous-work/image-upload/${merchant_id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100,
              );
              setPreviousImgProgress(progress);
            },
          },
        );

        uploadedImages.push(response.data.imageUrl);
      }

      setSelectedFiles([]);
      await getSingleDocumentHandler();
      toast.success("Images uploaded successfully!");
    } catch (error) {
      setUploadErrors(["Upload failed"]);
    } finally {
      setUploading(false);
      setPreviousImgProgress(0);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [],
    },
    multiple: true,
    disabled: uploading,
  });

  useEffect(() => {
    if (!merchant_id) return;
    getSingleDocumentHandler();
  }, [merchant_id]);

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header text-white d-flex justify-content-between align-items-center"
                style={{ backgroundColor: "#085f9a" }}
              >
                <h5 className="mb-0">
                  {language === "en"
                    ? "Add Business Photos"
                    : "व्यवसाय का फोटो डालें"}
                </h5>

                <Link
                  to="/dashboard/previous-work-list"
                  className="btn btn-light btn-sm"
                  style={{ fontWeight: "500" }}
                >
                  {language === "en" ? "View All" : "सभी देखें"}
                </Link>
              </div>
              <div className="card-body">
                <div className="row">
                  {uploadErrors.length > 0 && (
                    <div className="alert alert-danger mt-2">
                      <ul className="mb-0">
                        {uploadErrors.map((err, index) => (
                          <li key={index}>{err}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <div
                    {...getRootProps()}
                    style={{
                      border: "2px dashed #085f9a",
                      borderRadius: "10px",
                      padding: "30px",
                      textAlign: "center",
                      marginBottom: "20px",
                      cursor: "pointer",
                      background: isDragActive ? "#f0f8ff" : "#fff",
                    }}
                  >
                    <input {...getInputProps()} />
                    <i
                      className="fa fa-cloud-upload"
                      style={{ fontSize: "30px" }}
                    ></i>
                    <p className="mt-2">
                      {isDragActive
                        ? "Drop images here..."
                        : "Drag & drop images here or click to select"}
                    </p>
                  </div>
                  <div className="row">
                    {selectedFiles.map((file, index) => (
                      <div className="col-md-2 col-6 mb-3" key={index}>
                        <div style={{ position: "relative" }}>
                          <img
                            src={file.preview}
                            alt="preview"
                            style={{
                              width: "100%",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "10px",
                              border: "2px solid #ddd",
                            }}
                          />
                          <button
                            onClick={() => removeImage(index)}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              background: "red",
                              color: "#fff",
                              border: "none",
                              borderRadius: "50%",
                              width: "25px",
                              height: "25px",
                              cursor: "pointer",
                            }}
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                  {(previousImgProgress > 0 || uploading) && (
                    <div className="mt-3">
                      <div
                        className="progress bg-white"
                        style={{ height: "15px" }}
                      >
                        <div
                          className="progress-bar progress-bar-striped bg-success"
                          role="progressbar"
                          style={{ width: `${previousImgProgress}%` }}
                          aria-valuenow={previousImgProgress}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {previousImgProgress}%
                        </div>
                      </div>
                      <small className="text-muted">
                        {language === "en"
                          ? "Uploading images..."
                          : "छवियाँ अपलोड हो रही हैं..."}
                      </small>
                    </div>
                  )}
                  <div className="text-center mt-3">
                    <button
                      className="btn btn-primary"
                      style={{backgroundColor:'#085f9a'}}
                      onClick={handleUpload}
                      disabled={uploading || selectedFiles.length === 0}
                    >
                      {uploading ? "Uploading..." : "Submit Images"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPreviousWork;
